/**
 * Hosts that serve the Preview environment: the shared preview site and its per-PR Firebase Hosting
 * preview channels, e.g. `hub-web-preview--pr123-a1b2c3d4.web.app`.
 * Keep in sync with the channel naming in `.github/workflows/workflow_call.deploy.yml`.
 */
const PREVIEW_HOSTNAME_PATTERN = /^hub-web-preview(--[a-z0-9-]+)?\.web\.app$/;

/**
 * Whether the internal `/sandbox` route is available: local development, the osdev.tech environments
 * and the Preview environment (including PR previews). Never production.
 */
export function isSandboxRouteEnabled(location: Pick<Location, "href" | "hostname">, nodeEnv?: string): boolean {
  return (
    nodeEnv === "development" ||
    location.href.includes("osdev.tech") ||
    PREVIEW_HOSTNAME_PATTERN.test(location.hostname)
  );
}
